<template>
  <div class="dummy">
    <slick
      ref="slick"
      :options="slickOptions">
      <a href="http://placehold.it/2000x1000">
        <video ref="video" width="100%" controls 
              preload="metadata"
              poster="/static/v3/static/img/loading-animation-css.gif">
          <source src="http://localhost:8000/media/content/videos/PL_birthday_edit_-1043.mp4" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
      </a>
      <a href="http://placehold.it/2000x1000"><img src="http://placehold.it/2000x1000" alt=""></a>
      <a href="http://placehold.it/2000x1000"><img src="http://placehold.it/2000x1000" alt=""></a>
      <a href="http://placehold.it/2000x1000"><img src="http://placehold.it/2000x1000" alt=""></a>
      <a href="http://placehold.it/2000x1000"><img src="http://placehold.it/2000x1000" alt=""></a>
    </slick>
  </div>
</template>

<script>
import Slick from 'vue-slick'

export default {
  name: 'adx-dummy',
  components: {
    'slick': Slick
  },
  props: {

  },
  data() {
    return {
      slickOptions: {
          slidesToShow: 1,
          // Any other options that can be got from plugin documentation
      },
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>